/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { Data as AnatyticsData } from 'cio/utils/analytics/transforms';

enum FeedbackOption {
  NotUsingLanguageTags = 'optionNotUsingLanguageTags',
  UsingSegments = 'optionUsingSegments',
  Other = 'optionOther',
}

const FEEDBACK_OPTIONS = [
  {
    label: 'I need a different value than IETF or ISO language codes',
    value: FeedbackOption.NotUsingLanguageTags,
  },
  {
    label: 'I define languages using segments',
    value: FeedbackOption.UsingSegments,
  },
  {
    label: 'Other',
    value: FeedbackOption.Other,
  },
];

interface AttributeFeedbackFormArgs extends HelpModalComponentArgs {
  analyticsData?: AnatyticsData;
}

export default class LanguageAttributeFeedbackForm extends Component<AttributeFeedbackFormArgs> {
  @service analytics!: AnalyticsService;

  FeedbackOptions = FEEDBACK_OPTIONS;

  get allOptionsFalse() {
    return FEEDBACK_OPTIONS.every((o) => !this[o.value]);
  }

  get submitDisabled() {
    if ((this.optionOther && this.otherDetail.trim().length < 1) || this.allOptionsFalse) {
      return true;
    }

    return false;
  }

  get disabledTooltipContent() {
    if (this.allOptionsFalse) {
      return 'Please select at least one option';
    }

    if (this.optionOther && this.otherDetail.trim().length < 1) {
      return 'Please provide feedback for "Other"';
    }

    return '';
  }

  @tracked optionUsingSegments = false;
  @tracked optionNotUsingLanguageTags = false;
  @tracked optionOther = false;
  @tracked otherDetail = '';

  @action
  onInsert() {
    let source =
      this.args.analyticsData?.source != null ? this.args.analyticsData.source : 'Settings - Language Attribute';

    this.analytics.track('user', 'feedback_request_started', { source });
  }

  @action
  cancel() {
    this.analytics.track('languages', 'feedback_canceled', this.args.analyticsData);
    this.args.onClose();
  }

  @action
  focusTextarea(element: HTMLTextAreaElement) {
    if (this.optionOther) {
      element.focus();
    }
  }

  @action
  onSubmit(e: Event) {
    e.preventDefault();

    let praise = FEEDBACK_OPTIONS.filter((o) => this[o.value])
      .map((o) => {
        if (o.value === FeedbackOption.Other) {
          return `Other: ${this.otherDetail.trim()}`;
        }

        return o.label;
      })
      .join('\r\n');

    this.args.onSubmit({
      criticism:
        'Multi-language feedback: What would work better for you than defining an attribute and/or using IETF values?',
      praise,
    });
  }
}
